import columns from './statistics-columns';

export default () => ({
    columns: [columns.processor, columns.count, { ...columns.amount, headerName: 'Amount' }],
});
